import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Tooltip, Fab } from "@mui/material";
import { Add } from "@mui/icons-material";
import { Link, useNavigate } from "react-router-dom";
import { httpGet } from "../../utils/api";
import { BASE_URL } from "../../config/endPoint";
import DashboardLayout from "../../components/layouts/dashboardLayout";

const Category = () => {
  const [search, setSearch] = useState("");
  const [categoryList, setCategoryList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    getCategory();
  }, []);

  const getCategory = async () => {
    setIsLoading(true);
    try {
      const res = await httpGet(`${BASE_URL}/category/list`);
      if (res?.data?.status) {
        setCategoryList(res.data.response);
      }
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };

  // ✅ TABLE COLUMNS
  const columns = [
    {
      name: (
        <h6>
          <b>Category Name</b>
        </h6>
      ),
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: (
        <h6>
          <b>Date</b>
        </h6>
      ),
      selector: (row) =>
        row.createdAt
          ? new Date(row.createdAt).toLocaleDateString("en-IN")
          : "-",
      sortable: true,
    },
    {
      name: (
        <h6>
          <b>Action</b>
        </h6>
      ),
      cell: (row) => (
        <div style={{ display: "flex", gap: "10px" }}>
          <button
            onClick={() => navigate(`/editCategory/${row._id}`)}
            style={{
              border: "none",
              background: "transparent",
              cursor: "pointer",
            }}
          >
            <i
              className="fa-solid fa-pen fa-lg"
              style={{ color: "blue" }}
            ></i>
          </button>
        </div>
      ),
    },
  ];

  // ✅ SEARCH FILTER
  const filteredItems = categoryList.filter(
    (item) =>
      item.name && item.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <DashboardLayout>
      <div className="table-outer">
        <DataTable
          className="table"
          title="Category"
          columns={columns}
          data={filteredItems}
          pagination
          fixedHeader
          progressPending={isLoading}
          selectableRowsHighlight
          highlightOnHover
          subHeader
          subHeaderComponent={
            <input
              type="text"
              placeholder="Search here"
              className="form-control"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          }
        />

        {/* ✅ ADD CATEGORY BUTTON */}
        <Tooltip title="Add Category">
          <Fab
            style={{
              position: "fixed",
              bottom: "30px",
              right: "30px",
              backgroundColor: "#f6e58d",
            }}
          >
            <Link to="/addCategory">
              <Add fontSize="large" style={{ color: "#000" }} />
            </Link>
          </Fab>
        </Tooltip>
      </div>
    </DashboardLayout>
  );
};

export default Category;
